"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var props = _ref.props,
      monitor = _ref.monitor;
  return props.canDrop;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/canDrop/hasCanDropPredicate.js
// module id = 1973
// module chunks = 0